module.exports = __webpack_public_path__ + "img/fail.56915b75.png";